const hashJavaString = (value = '') => {
  let hash = 0
  for (let index = 0; index < value.length; index += 1) {
    hash = ((hash * 31) + value.charCodeAt(index)) | 0
  }
  return (hash >>> 0).toString(16)
}

export const buildCompletenessSourceVersion = (annotationValue, featureValue) => {
  return hashJavaString(`${annotationValue || ''}||${featureValue || ''}`)
}

export const isCompletenessSourceStale = ({
  hasAnnotationContent,
  resultSourceVersion,
  currentSourceVersion,
} = {}) => {
  if (!hasAnnotationContent || !resultSourceVersion) {
    return false
  }
  return resultSourceVersion !== currentSourceVersion
}

export const buildCompletenessAddIssueResult = ({
  resultData,
  currentSourceVersion,
  annotationCount,
  featureCount,
  nextIssue,
} = {}) => {
  const currentIssues = Array.isArray(resultData?.issues) ? resultData.issues : []
  const sourceVersion = resultData?.sourceVersion || currentSourceVersion || ''

  return {
    ...(resultData || {}),
    sourceVersion,
    updatedAt: resultData?.updatedAt || '',
    paragraphCount: Number(annotationCount || 0),
    featureCount: Number(featureCount || 0),
    issueCount: currentIssues.length + 1,
    issues: [...currentIssues, nextIssue],
  }
}
